// @ts-nocheck
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../../_dashboard/helpers'

type Props = {
  id: string
}

const MailOrderActionsCell: FC<Props> = ({id}) => {
  const intl = useIntl()
  const navigate = useNavigate()

  return (
    <button
      type='button'
      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
      title={intl.formatMessage({id: 'MAIL_ORDER.ACTIONS.VIEW'})}
      onClick={() => navigate(`/apps/mail-orders/${id}`)}
    >
      <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
    </button>
  )
}

export {MailOrderActionsCell}
